<div class="footer">
    <!-- <div class="version">v.0.105.4</div> -->
    <div class="copyright"> © <a href="https://ciright.com/" target="_blank">Ciright</a></div>
  </div>